import { apiCall } from "@/common/api/ApiResult.model";
import {
  RiskyEventReportConfig,
  DEFAULT_RISKY_EVENT_REPORT_CONFIG,
} from "./model";
import axios from "axios";

export const get_risky_event_report_config = apiCall<
  void,
  RiskyEventReportConfig
>("scheduled-reports.risky_events.get", async () => {
  const res = await axios.get("/risky-events-reporter");
  return {
    success: true,
    value: res.status == 204 ? DEFAULT_RISKY_EVENT_REPORT_CONFIG : res.data,
  };
});

export const set_risky_event_report_config = apiCall<
  Pick<RiskyEventReportConfig, "severities" | "isActive" | "recipients">,
  RiskyEventReportConfig
>("scheduled-reports.risky_events.get", async (payload) => {
  console.log("set_risky_event_report_config:", payload);
  const res = await axios.post("/risky-events-reporter", payload);
  return {
    success: true,
    value: res.data,
  };
});
